import { _API, _AXIOS_HELPER, _HEADER } from "@/static";
import * as ENUM from "@/enum/lib";

export default {
    getAllSelectedExerciseHistoryRecord( seqExercise ) {
        return new Promise( ( resolve, reject ) => {
            const url = _API + '/exercise/getAllSelectedExerciseHistoryRecord/v2';
            const conf = {
                headers: _HEADER()
            };

            const data = { seqExercise };

            _AXIOS_HELPER( ENUM.HTTP_METHOD.POST, url, data, conf )
                .then( res => {
                    resolve( res );
                } )
                .catch( err => {
                    reject( err );
                } );
        } );
    }
}